import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.chat.newMessageAdded;

const getNewMessageAddedFlag = createSelector(
  getData,
  newMessageAdded => newMessageAdded
);

export default getNewMessageAddedFlag;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getNewMessageAddedFlag.js